export const IMAGE_STYLES = {
  NONE: 'AIPlugin_ImageStyle_None',
  DIGITAL_ART: 'AIPlugin_ImageStyle_DigitalArt',
  FANTASY_ART: 'AIPlugin_ImageStyle_Fantasy',
  LINE_ART: 'AIPlugin_ImageStyle_Sketch',
  CINEMATIC: 'AIPlugin_ImageStyle_Cinematic',
  COMIC_BOOK: 'AIPlugin_ImageStyle_ComicBook',
  NEON_PUNK: 'AIPlugin_ImageStyle_NeonPunk',
  MODEL_3D: 'AIPlugin_ImageStyle_3D',
  LOW_POLY: 'AIPlugin_ImageStyle_LowPoly',
  ANIME: 'AIPlugin_ImageStyle_Anime',
  ISOMETRIC: 'AIPlugin_ImageStyle_Isometric',
};
